var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreesRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 355.76 229.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M289 167.51s2.53 14.55 15.19 36.36l-9.3-2.15-1.68 6.69-10.83-4-3.08 7.1-12.49-5-7.13 6.32-9.75-6.12-14.4 6.12-6.95-8.31-12.87 4.7-1.87-9.22-16.24 3.8s9.14-10.5 17.34-36.32c38.19-.28 74.06.03 74.06.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M279.88 135.16s.8 17.76 17.37 37.82l-12.61-3.61 2.52 8.83-15.66-4.45-4.88 9.66-8-9.26-11.78 9.66-7.56-10-10.7 6.82-1.48-9.63-9.57 6.46-1.5-9.18-18.42 6s20.94-13.81 22.48-39.06c30.84-.37 59.79-.06 59.79-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M226.36 115.47s-11.17 32.64-22.44 39.46l18.23-7.23v11.64l11-10.43 4 10.43 6.48-8 5.51 8 4.63-7.81 7.59 5.7 4.2-7.46 11.94 7.16 1.94-12.78 11.76 5.16s-13-14-16.57-33.84c-24.93-.26-48.27 0-48.27 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M249.22 45.28s17.11 57.94 33.74 77.08l-10.41-4.31-2.13 7.23-8.18-6.37-4.24 7.27-3-5.18-7.73 4.64-5.66-7.45-11.48 7.27-3.63-7.19-11.31 7.89s28.41-48.01 34.03-80.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M246.67 35s14.14 47.88 27.89 63.7L266 95.09l-4.14 6-6-5.27-6 6.46-9.44-7-9.48 6-3-5.94-9.35 6.52S242 62.11 246.67 35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M250.15 23.55s-14.85 42.74-28 56.38l8-2.78 3.5 5.65 5.64-4.47 5.2 6.18 8.86-5.9 8.36 6 3-5.24 8.22 6.41s-19.71-37.32-22.78-62.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M337.33 174.61s3.07 17.65 18.43 44.11l-11.28-2.61-2 8.12-13.14-4.88-3.77 8.65-15.15-6.05-8.66 7.66-11.76-7.45-17.47 7.41-8.53-10.08-15.6 5.7-2.25-11.13-19.7 4.61s11.09-12.73 21-44.06c46.4-.37 89.88 0 89.88 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M326.3 135.37s1 21.55 21.07 45.88l-15.3-4.38 3.06 10.71-19-5.39-5.92 11.71-9.77-11.23-14.27 11.72-9.17-12.17-13 8.28-1.75-11.68-11.62 7.84-1.81-11.13-22.35 7.22s25.4-16.75 27.27-47.38c37.44-.37 72.56 0 72.56 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M261.38 111.49s-13.56 39.59-27.22 47.86l22.11-8.76v14.11l13.3-12.65 4.8 12.65 7.87-9.73 6.69 9.73 5.61-9.46 9.21 6.9 5.09-9 14.49 8.68 2.35-15.5 14.26 6.26s-15.74-17-20.1-41c-30.16-.41-58.46-.09-58.46-.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M289.11 26.35s20.75 70.28 40.92 93.5l-12.63-5.23-2.58 8.78-9.92-7.73-5.17 8.81-3.62-6.26-9.37 5.63-6.86-9-13.88 8.78-4.4-8.72-13.73 9.57s34.42-58.26 41.24-98.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M286 13.82s17.15 58.08 33.82 77.27l-10.42-4.32-5 7.25-7.24-6.38-7.3 7.83-11.45-8.54-11.51 7.29-3.66-7.22-11.34 7.92s28.48-48.15 34.1-81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M290.24 0s-18 51.84-34 68.39l9.69-3.39 4.25 6.85 6.82-5.41 6.31 7.49 10.75-7.15L304.22 74l3.61-6.35 10 7.77S294 30.21 290.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M196.81 175.36s1.66 9.55 10 23.87l-6.1-1.41-1.1 4.4-7.12-2.64-2 4.66-8.2-3.28-4.69 4.15-6.39-4-9.46 4-4.57-5.46-8.45 3.09-1.21-6-10.67 2.5s6-6.89 11.39-23.85c25.03-.24 48.57-.03 48.57-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M190.83 154.11s.53 11.67 11.41 24.84l-8.24-2.37 1.66 5.79-10.29-2.91-3.2 6.34-5.29-6.08-7.73 6.34-5-6.58-7 4.48-.94-6.33-6.29 4.25-1-6-12.09 3.91s13.75-9.07 14.76-25.65c20.23-.23 39.24-.03 39.24-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M155.69 141.18s-7.34 21.43-14.74 25.91l12-4.74V170l7.19-6.85 2.6 6.85 4.26-5.27 3.6 5.27 3-5.13 5 3.75 2.75-4.9 7.85 4.7 1.3-8.42 7.72 3.38a49.2 49.2 0 01-10.88-22.22c-16.34-.16-31.65.02-31.65.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M170.7 95.08s11.24 38.06 22.16 50.63l-6.86-2.83-1.4 4.75-5.37-4.19-2.8 4.77-2-3.39-5.07 3.05-3.66-4.87-7.54 4.77-2.38-4.77-7.43 5.18s18.65-31.51 22.35-53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M169 88.3s9.28 31.45 18.31 41.84l-5.65-2.34-2.66 3.92-3.92-3.45-4 4.24-6.19-4.63-6.23 4-2-3.9-6.14 4.28S166 106.14 169 88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M171.31 80.82s-9.75 28.07-18.38 37l5.22-1.83 2.31 3.7 3.7-2.93 3.41 4.06 5.82-3.88 5.49 3.91 2-3.44 5.39 4.21s-12.94-24.44-14.96-40.8zM109 191.73s1.66 9.56 10 23.88l-6.11-1.41-1.1 4.39-7.19-2.59-2 4.66-8.2-3.27-4.69 4.14-6.39-4-9.46 4-4.59-5.53-8.45 3.08-1.21-6-10.67 2.49s6-6.89 11.39-23.85c25.08-.19 48.67.01 48.67.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M103 170.49s.52 11.66 11.4 24.83l-8.3-2.32 1.66 5.8-10.29-2.92-3.2 6.34-5.27-6.13-7.73 6.35-5-6.59-7 4.48-.95-6.33-6.32 4.25-1-6-12 3.88s13.75-9.06 14.76-25.64c20.24-.21 39.24 0 39.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M67.83 157.56S60.49 179 53.09 183.47l12-4.75v7.64l7.19-6.85 2.61 6.85 4.25-5.26 3.62 5.26 3-5.12 5 3.74 2.75-4.9 7.85 4.7 1.27-8.39 7.72 3.39a49.2 49.2 0 01-10.88-22.22c-16.32-.18-31.64 0-31.64 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M82.84 111.46s11.24 38.05 22.16 50.62l-6.84-2.83-1.4 4.75-5.37-4.18-2.8 4.77-2-3.39-5.07 3.05-3.72-4.9-7.54 4.78-2.38-4.72-7.43 5.18s18.7-31.54 22.39-53.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M81.17 104.68s9.28 31.44 18.31 41.83l-5.65-2.34-2.72 3.93-3.92-3.46-4 4.24-6.19-4.62-6.23 3.94-2-3.9-6.14 4.28s15.49-26.06 18.54-43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c9df",
    d: "M83.45 97.2s-9.75 28.06-18.38 37l5.23-1.83 2.3 3.71 3.7-2.94 3.41 4.06 5.82-3.87 5.49 3.9 2-3.44 5.35 4.21s-12.9-24.45-14.92-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M228.56 180s2 11.59 12.1 29l-7.41-1.72-1.33 5.33-8.63-3.2-2.45 5.65-10-4-5.69 5-7.76-4.87-11.39 4.92-5.54-6.62-10.24 3.75-1.48-7.31-12.93 3s7.27-8.36 13.81-28.93c30.38-.22 58.94 0 58.94 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M221.32 154.25s.63 14.15 13.83 30.13l-10-2.88 2 7-12.51-3.5-3.88 7.69-6.41-7.38L195 193l-6-8-8.52 5.43-1.14-7.67-7.63 5.15-1.2-7.31-14.67 4.74s16.68-11 17.91-31.11c24.5-.23 47.57.02 47.57.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M178.68 138.57s-8.9 26-17.87 31.43l14.52-5.75v9.26l8.73-8.31 3.16 8.31 5.16-6.39 4.4 6.39 3.68-6.21 6 4.53 3.34-5.94 9.52 5.71 1.54-10.19 9.36 4.11s-10.33-11.18-13.2-27c-19.75-.16-38.34.05-38.34.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M196.89 82.65s13.63 46.16 26.88 61.41l-8.3-3.44-1.69 5.77-6.52-5.08-3.39 5.79-2.38-4.1-6.15 3.7-4.51-5.94-9.14 5.79-2.89-5.73-9 6.29s22.62-38.27 27.09-64.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M194.86 74.43s11.27 38.14 22.21 50.74l-6.85-2.84-3.3 4.77-4.75-4.2-4.8 5.15-7.52-5.61-7.55 4.78-2.39-4.73-7.45 5.19s18.7-31.61 22.4-53.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M197.64 65.35s-11.84 34.05-22.31 44.91l6.35-2.22 2.79 4.5L189 109l4.14 4.92 7.06-4.7 6.66 4.74 2.37-4.17 6.54 5.11s-15.69-29.71-18.13-49.55zM71.32 197.42s2 10.26 11.86 25.64l-7.26-1.52-1.31 4.72-8.46-2.83-2.4 5-9.75-3.52-5.57 4.46-7.6-4.32-11.24 4.32-5.43-5.86-10 3.31-1.45-6.47L0 223s7.13-7.4 13.53-25.61c29.81-.19 57.79.03 57.79.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M64.22 174.6s.62 12.53 13.56 26.68l-9.85-2.55 2 6.22-12.22-3.13-3.81 6.81-6.28-6.53-9.19 6.81-5.9-7.07-8.35 4.81-1.18-6.79-7.48 4.56-1.14-6.42L0 202.15s16.35-9.74 17.55-27.55c24.07-.21 46.67 0 46.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M22.44 160.72s-8.72 23-17.51 27.82l14.23-5.09v8.21l8.55-7.36 3.1 7.36 5.06-5.66 4.3 5.66 3.62-5.51 5.92 4 3.29-5.24 9.31 5.09 1.51-9 9.18 3.58s-10.13-9.9-12.94-23.86c-19.4-.18-37.62 0-37.62 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M40.29 111.22s13.35 40.86 26.33 54.36l-8.13-3-1.66 5.1-6.38-4.49-3.33 5.12-2.32-3.64-6 3.28-4.42-5.26-9 5.13-2.83-5.07-8.84 5.56s22.19-33.91 26.58-57.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M38.3 103.94s11 33.77 21.76 44.92l-6.71-2.51-3.23 4.22-4.66-3.72-4.7 4.56-7.37-5-7.39 4.27-2.34-4.19-7.3 4.6s18.32-27.99 21.94-47.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M41 95.91S29.42 126 19.16 135.66l6.22-2 2.73 4 4.4-3.15 4.06 4.36 6.92-4.16 6.51 4.21 2.32-3.69 6.42 4.52S43.41 113.47 41 95.91zM156.72 187.5s2 11.59 12.1 29l-7.41-1.72-1.34 5.33-8.63-3.2-2.44 5.62-9.94-4-5.69 5-7.76-4.87-11.47 4.87-5.55-6.53-10.25 3.75-1.47-7.31-12.94 3s7.28-8.36 13.81-28.93c30.42-.25 58.98-.01 58.98-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M149.47 161.73s.63 14.15 13.84 30.13L153.26 189l2 7-12.47-3.54-3.89 7.7-6.41-7.38-9.38 7.7-6-8-8.52 5.43-1.15-7.67-7.63 5.15-1.19-7.31-14.68 4.74s16.68-11 17.91-31.11c24.56-.22 47.62.02 47.62.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M106.84 146.05S97.94 172 89 177.48l14.52-5.75V181l8.73-8.31 3.15 8.31 5.17-6.39 4.39 6.39 3.69-6.22 6 4.54 3.34-5.94 9.52 5.71 1.55-10.19 9.36 4.11s-10.33-11.18-13.2-26.95c-19.79-.22-38.38-.01-38.38-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M125.05 90.13s13.63 46.16 26.87 61.41l-8.29-3.44-1.7 5.77-6.51-5.08-3.4 5.79-2.37-4.11-6.15 3.7-4.5-5.94-9.16 5.77-2.84-5.71-9 6.29s22.57-38.26 27.05-64.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M123 81.91s11.26 38.14 22.21 50.74l-6.86-2.84-3.29 4.77-4.75-4.2-4.8 5.15-7.51-5.61-7.56 4.78-2.38-4.7-7.45 5.19s18.71-31.64 22.39-53.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ad1e2",
    d: "M125.79 72.83s-11.83 34.05-22.3 44.91l6.34-2.22 2.79 4.5 4.49-3.56 4.14 4.92 7.07-4.7 6.66 4.74 2.36-4.17 6.55 5.1s-15.65-29.68-18.1-49.52z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesRight);
export default __webpack_public_path__ + "static/media/trees-right.8693810a.svg";
export { ForwardRef as ReactComponent };